import React, { Component } from "react";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedback: "",
      name: "",
      email: "",
      status: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    return (
      <div>
        <div className="Contact">
          <form className="test-mailing">
            <p>
              Shoot me an email with your inquiry and contact info and I will
              get back to you!
            </p>
            <div>
              <input
                type="text"
                name="name"
                onChange={this.handleChange}
                placeholder="your name"
                required
                value={this.state.name}
                style={{ width: "100%", marginBottom: "10px" }}
              />
              <input
                type="email"
                name="email"
                onChange={this.handleChange}
                placeholder="your email"
                required
                value={this.state.email}
                style={{ width: "100%", marginBottom: "10px" }}
              />
              <textarea
                id="portfolioinquery"
                name="feedback"
                onChange={this.handleChange}
                placeholder="your inquiry"
                required
                value={this.state.feedback}
                style={{ width: "100%", height: "150px" }}
              />
            </div>
            <input
              type="button"
              value="send"
              className="btn btn--submit"
              onClick={this.handleSubmit}
            />
            {this.state.status && <p>{this.state.status}</p>}
          </form>
        </div>
      </div>
    );
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit() {
    if (!this.state.name.trim() || !this.state.email.trim() || !this.state.feedback.trim()) {
      this.setState({
        status: "Please fill out your name, email, and inquiry before sending.",
      });
      return;
    }

    const templateId = "portfolioinquery";

    this.setState({ status: "Sending..." });
    this.sendFeedback(templateId, {
      message_html: this.state.feedback,
      from_name: this.state.name,
      reply_to: this.state.email,
    });
  }

  sendFeedback(templateId, variables) {
    window.emailjs
      .send(
        "gmail_service_l3hwr03",
        templateId, //service_id, template_id
        variables
      )
      .then(() => {
        this.setState({
          feedback: "",
          name: "",
          email: "",
          status: "Email sent successfully! I'll get back to you soon.",
        });
      })
      .catch((err) => {
        console.error("Email failed:", err);
        this.setState({
          status:
            "Sorry, something went wrong sending your message. Please try again in a bit.",
        });
      });
  }
}
